var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-message-item"},[_c('img',{directives:[{name:"src",rawName:"v-src",value:(_vm.message.avatar),expression:"message.avatar"}],staticClass:"user-avatar"}),_c('div',{staticClass:"user-nickname"},[_vm._v(_vm._s(_vm.message.nickname))]),_c('div',{staticClass:"message-content"},[_vm._v(":"+_vm._s(_vm.message.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }